
import { defineComponent } from 'vue'
import Newest from '@/components/Blog/newest.vue'
import Category from '@/components/Blog/category.vue'
import CategoryHead from '@/components/Title/CategoryHead.vue'
export default defineComponent({
  components: {
    CategoryHead,
    Newest,
    Category
  }
})
